import frMessages from "../locales/fr";

const FrLang = {
  messages: {
    ...frMessages
  },
  locale: "fr-FR"
};
export default FrLang;
